<template>
  <div class="page" v-wechat-title="$route.meta.title='收听历史'">

    <div class="list border-box">
      <template  v-for="(item,index) in root">
        <div v-if='index>0'>
          <div v-if="root[index-1].ordertime!=item.ordertime">
            <p class="title border-box">{{item.ordertime}}</p>
          </div>
        </div>
        <div v-if='index==0'>
          <p class="title border-box">{{item.ordertime}}</p>
        </div>
        <div class="list-box box border-box" @click="goVideoDes(item.id,item.shopid,item.bagtype)">
          <span class="list-circle"></span>
          <span class="list-line"></span>
          <div class="block list-img">
            <img class="img bor50" v-lazy="item.guideheadimg2?item.guideheadimg2:item.userheadimg" alt="">
          </div>
          <div class="block flex list-info">
            <p class="list-group hide">{{item.shopname}}</p>
            <p class="list-name hide">{{item.bagname}}</p>
            <p class="list-editor hide">{{item.guidename2?item.guidename2:item.username}}{{item.description?('/'+item.description):''}}</p>
          </div>
        </div>
      </template>

      <p class="load-tip" ref="loadtip">{{loadText}}</p>
    </div>


  </div>
</template>
<script>

  import { mapState, mapMutations } from 'vuex'
  import { getListenHistory} from "@/service/getData";
  import { loadMore } from "@/config/mUtils";
  import {setStore, getStore, removeStore} from '@/config/mUtils'

  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)


  export default {
    data(){
      return{
        userInfo: {},
        total:'',
        root: [],
        page: 1,
        rows: 10,
        loadText: "数据加载中",

        TimeStamp: new Date().getTime(),  //获取当前时间
      }
    },
    computed: {

    },
    created() {
      this.$loading.show('数据加载中');
      this.initData(this.page);

      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
    },
    methods: {
      async initData(page) {
        this.userInfo = getStore("userInfo");
        let res = await getListenHistory({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          page: page,
          rows: this.rows,
          from: 'h5'
        });

        if (res.errcode === '00000'){
          this.$loading.hide();
          this.total = res.data.total;
          let root = res.data.root;

          if (page >= Math.ceil(this.total / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (root.length > 0) {
            this.root = [...this.root, ...root];
          } else {
            if (page == 1) {
              this.root = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page);
          });
        })
      },

      //跳转到专辑详情页
      goVideoDes(id,shopid,bagtype){
        if(bagtype==2){
          this.$router.push({
            path: `/video-vr?${'id='+ id + '&TimeStamp='+ this.TimeStamp+'&shopid='+shopid}`
          });
        }else {
          this.$router.push({
            path: `/video-play?${'id='+ id + '&TimeStamp='+ this.TimeStamp+'&shopid='+shopid}`
          });
        }
      },

    },
    components: {

    },

  }

</script>

<style scoped>

  .page{min-height:100vh;background:#fafafa;}
  .title{width:100%;height:.72rem;line-height:.72rem;padding:0 .10rem;margin:0 0 .05rem -.44rem;font-size:.30rem;color:#fa9900;}
  .list{padding:0 .25rem 0 .54rem;}
  .list .list-box{position:relative;width:100%;height:1.69rem;padding:.18rem .20rem;margin-top:.30rem;border:1px solid #eee;-webkit-border-radius:.13rem;border-radius:.13rem;background:#fff;}
  .list .list-box:nth-of-type(1){margin-top:.10rem;}
  .list-circle{position:absolute;top:-.02rem;left:-.40rem;width:.12rem;height:.12rem;border:.06rem solid #fa9900;background:#fafafa;-webkit-border-radius:50%;border-radius:50%;}
  .list-line{position:absolute;top:.32rem;bottom:-.15rem;left:-.30rem;width:.04rem;background:#eee;}
  .list .list-box:last-child .list-line{display:none;}
  .list-img{float:left;position:relative;width:1.45rem;height:1.28rem;border-right:1px solid #eee;}
  .list-img img{width:1.27rem;height:1.28rem;background:#fff;}
  .list-info{padding-left:.20rem;}
  .list-group{font-size:.20rem;color:#fa9900;}
  .list-name{margin-top:.14rem;font-size:.32rem;color:#6f7f84;}
  .list-editor{margin-top:.08rem;font-size:.20rem;color:#bbc4b8;}


</style>



// WEBPACK FOOTER //
// src/page/listen-history/listen-history.vue